// extracted by mini-css-extract-plugin
module.exports = {"policies":"policies_policies__MCIRN"};